import { NewDynamicTab } from "../../../components/Page";
import { GridcoPowerProcurementDefaultDates } from "../../../config/DefaultDates";
import { GridcoTitle } from "../components";
import { TabSwitcher } from "../Gridco_Das";
import Collective from "./Collective";

export function GridcoPowerProcurement() {
  return (
    <NewDynamicTab
      trendTabs={["Trend Analysis"]}
      defaultDates={GridcoPowerProcurementDefaultDates}
      header="Power Procurement"
      headerPrefixComponent={<TabSwitcher />}
      middleComponent={<GridcoTitle />}
      tabs={{
        Collective: <Collective />,
      }}
    />
  );
}
